import { sleep } from '@weavix/utils/src/sleep';

export async function timeout(errorMessage: string = 'timeout'): Promise<never> {
    const error = new Error(`mqtt-service: ${errorMessage}`);
    await sleep(10_000);
    throw error;
}
